import { createIntl, createIntlCache } from 'react-intl';
import _ from 'lodash';
import French from '../../lang/fr.json';
import English from '../../lang/en.json';
import { COUNTRY } from '../environment';
import { getPreferenceTz } from './timezone';

const intl = () => {
  const cache = createIntlCache();
  const locale = localStorage.getItem('locale') || 'en';
  const messages = locale === 'en' ? English : French;

  return createIntl({ locale, messages }, cache);
};

const { formatMessage, formatDate, formatNumber } = intl();

const makeRenderer = opts => date =>
  formatDate(date, { ...opts, timeZone: getPreferenceTz() });

export const renderDateTime = makeRenderer({ month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: 'numeric' });
export const renderTime = makeRenderer({ hour: 'numeric', minute: 'numeric' });
export const renderDate = makeRenderer({ month: 'short', day: 'numeric', year: 'numeric' });
export const renderDateLong = makeRenderer({ month: 'long', day: 'numeric', year: 'numeric' });
export const renderDayDate = makeRenderer({ weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' });
export const renderDateTimeLong = makeRenderer({ month: 'long', day: 'numeric', year: 'numeric', hour: 'numeric', minute: 'numeric' });

export const renderAppointmentModality = modality => {
  switch (modality) {
    case 'video':
      return formatMessage({ defaultMessage: 'Video' });
    case 'voice':
      return formatMessage({ defaultMessage: 'Voice' });
    case 'in_person':
      return formatMessage({ defaultMessage: 'In Person' });
    default:
  }
  return formatMessage({ defaultMessage: 'Unknown' });
};

export const renderAppointmentType = type => {
  if (type === 'Couples') {
    return formatMessage({ defaultMessage: 'Couples' });
  }
  if (type === 'Specialized') {
    return formatMessage({ defaultMessage: 'Specialized' });
  }
  return formatMessage({ defaultMessage: 'Individual' });
};

export const renderSessionStatus = appointment => {
  const { status } = appointment;

  switch (status) {
    case 'scheduled':
      return formatMessage({ defaultMessage: 'Scheduled' });
    case 'completed':
      return formatMessage({ defaultMessage: 'Completed' });
    case 'failed':
      return formatMessage({ defaultMessage: 'Failed' });
    case 'canceled':
      return _.get(appointment, 'cancellation.reason.label');
    case 'in_progress':
      return formatMessage({ defaultMessage: 'In Progress' });
    case 'absent':
      return formatMessage({ defaultMessage: 'Absent' });
    case 'pending':
      return formatMessage({ defaultMessage: 'Pending' });
    default:
  }

  return status;
};

export const renderVideoType = type => {
  switch (type) {
    case 'Video':
      return formatMessage({ defaultMessage: 'Video' });
    case 'In Person':
      return formatMessage({ defaultMessage: 'In-Person' });
    case 'Voice':
      return formatMessage({ defaultMessage: 'Voice' });
    default:
  }

  return type;
};

export const renderCurrency = amount =>
  formatNumber(amount, {
    style: 'currency',
    currency: COUNTRY === 'US' ? 'USD' : 'CAD',
    currencyDisplay: 'narrowSymbol',
  });
